import { Component, Input } from '@angular/core';
import { TranslateService } from '@services/translate/translate.service';
import { DeeplTranslationService } from '@services/deepl-translation/deepl-translation.service';
import { MessengerService } from '@services/messenger/messenger.service';

@Component({
  selector: 'ibextouch-app',
  templateUrl: './ibextouch-app.component.html',
  styleUrls: ['./ibextouch-app.component.scss'],
  providers: [DeeplTranslationService],
  standalone: false
})
export class IbextouchAppComponent {

  @Input() item: any;
  @Input() packageId: any;
  codeEditorOptions = { maxLines: 30, minLines: 20, fontSize: '16px', autoScrollEditorIntoView: false };
  superadmin = false;

  constructor(private translate: TranslateService, private translation: DeeplTranslationService, private ms: MessengerService) {
    this.translate.get('general');
    this.ms.$superadminPrivileges.subscribe(privileges => {
      this.superadmin = !!(privileges || []).find(el => el.privilegeName === 'superadmin' && el.value === 'packages');
    });
  }

  clearInterval() {
    this.item.from = null;
    this.item.to = null;
  }

  async translateText(translation, language, field) {
    translation[field] = await this.translation.translate(this.item.translations.find(el => el.language === 'de')[field], language, this.packageId);
  }

  getTitle() {
    return this.item?.translations?.find(el => el.language === 'de')?.appTitle ?? '';
  }
}
